export enum LogoSizeEnum {
	SMALL = '8px',
	LARGE = '13px',
}

export enum LogoColorVariantEnum {
	DARK = 'dark',
	MEDIUM = 'medium',
	LIGHT = 'light',
	BLACK = 'black',
	WHITE = 'white',
	DISABLED = 'disabled',
}

export interface IAnimatedLogo {
	size?: LogoSizeEnum;
	colorVariant?: LogoColorVariantEnum;
}
